//Galerie d'images
const gallerySettings = {
  container: ".js-gallery",
  item: ".js-gallery-item",
  amount: 8,
};

let activeItems = gallerySettings.amount;

const galleryContainer = document.querySelector(gallerySettings.container);

document.addEventListener("DOMContentLoaded", () => {
  if (galleryContainer) {
    let items = galleryContainer.querySelectorAll(gallerySettings.item);

    if (items.length > activeItems) {
      hideExceedingImages(items, gallerySettings.amount);

      const moreBtn = document.createElement("div");
      moreBtn.innerText = "Voir la suite";
      moreBtn.classList.add("btn");
      moreBtn.classList.add("btn--primary");

      galleryContainer.after(moreBtn);

      moreBtn.addEventListener("click", () => {
        if (items.length > activeItems) {
          activeItems += 8;
          showExceedingImages(items, activeItems);
          if (activeItems >= items.length) {
            moreBtn.innerText = "Voir moins";
          }
        } else {
          hideExceedingImages(items, gallerySettings.amount);
          moreBtn.innerText = "Voir la suite";
          activeItems = 8;
        }
      });
    }
  }
});

const hideExceedingImages = (items, amount) => {
  items.forEach((item, index) => {
    if (index > amount - 1) {
      item.style.display = "none";
    }
  });
};

const showExceedingImages = (items, amount) => {
  items.forEach((item, index) => {
    if (index < amount) {
      item.style.display = "block";
    }
  });
};
